// 语种
const Language = {
    SC: 0,
    TC: 1,
    EN: 2,
    JP: 5,
};
// 语言query拼接
const LanguageQueryMap = {
    [Language.EN]: '&isHex=1&questionEN=',
    [Language.SC]: '&isHex=1&questionSC=',
    [Language.TC]: '&isHex=1&questionTC=',
    [Language.JP]: '&isHex=1&questionJA='
};
// AI场景-推送植入
const AI_SCENE_PUSH_INTEGRATION = 3;
// 生成AI链接
const AI_LINK = (isMM, scene, lang, question) => {
    if (!isMM) {
        const chatUrl = `https://chat-ai.futunn.com/?scene=${scene}${LanguageQueryMap[lang]}${question}`;
        return `futunn://url/${encodeURIComponent(chatUrl)}`;
    }
    const chatUrl = `https://chat-ai.moomoo.com/?scene=${scene}${LanguageQueryMap[lang]}${question}`;
    return `futumm://url/${encodeURIComponent(chatUrl)}`;
};

export {
    Language,
    LanguageQueryMap,
    AI_LINK,
    AI_SCENE_PUSH_INTEGRATION
};
